import { CurecallButton, ECurecallButtonAppearance, ECurecallSize } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'

interface Props {
  onSubmit: () => void
  onCancelFollowupForm?: () => void
}

const GenericFollowupActions = ({ onSubmit, onCancelFollowupForm }: Props) => {
  const { t } = useTranslation()
  return (
    <div className="c-sticky c-bottom-0 c-z-10 c-bg-white c-border-t c-border-grey-200 c-gap-8 c-flex c-mt-16 c-py-4 c-justify-center">
      <CurecallButton
        appearance={ECurecallButtonAppearance.CANCEL}
        size={ECurecallSize.SMALL}
        onClick={onCancelFollowupForm}
      >
        {t('common.actions.cancel')}
      </CurecallButton>
      <CurecallButton
        appearance={ECurecallButtonAppearance.PRIMARY}
        size={ECurecallSize.SMALL}
        onClick={onSubmit}
      >
        {t('common.actions.complete')}
      </CurecallButton>
    </div>
  )
}

export default GenericFollowupActions
